import { useState, useEffect } from "react";
import * as Slider from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";

const RangeSlider = ({ min, max, value, setValue, onPriceChange }) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (min !== undefined && max !== undefined && max > min) {
      const range = max - min;
      const stepValue = Math.pow(10, Math.floor(Math.log10(range)) - 2); 
      setStep(stepValue);
    }
  }, [min, max]);

  const handlePriceChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <div className="w-full pt-2">
      <Slider.Root
        className={cn("relative cursor-pointer flex items-center w-full touch-none")}
        value={value}
        onValueChange={handlePriceChange}
        onValueCommit={(newValue) => onPriceChange?.(newValue)}
        min={min}
        max={max}
        step={step}
        minStepsBetweenThumbs={1}
      >
        <Slider.Track className="bg-gray-300 relative h-[5px] grow rounded">
          <Slider.Range className="absolute bg-[#0b223c] h-[5px] rounded" />
        </Slider.Track>
        <Slider.Thumb
          className="ml-[1px] block w-5 h-5 bg-[#0b223c] rounded-full focus:outline-none focus:ring-2 focus:ring-gray-300"
          aria-label="Lower Bound"
        />
        <Slider.Thumb
          className="mr-[1px] block w-5 h-5 bg-[#0b223c] rounded-full focus:outline-none focus:ring-2 focus:ring-gray-300"
          aria-label="Upper Bound"
        />
      </Slider.Root>
      <div className="grid grid-cols-[1fr_auto_1fr] pt-4 text-lg">
        <span>${value[0]}</span> to <span className="justify-self-end">${value[1]}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
